module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7kaQV"))).then(() => parcelRequire('5erN3'));